import { render, staticRenderFns } from "./MerchantList.vue?vue&type=template&id=cd4b70ee&scoped=true&"
import script from "./MerchantList.vue?vue&type=script&lang=js&"
export * from "./MerchantList.vue?vue&type=script&lang=js&"
import style0 from "./MerchantList.vue?vue&type=style&index=0&id=cd4b70ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4b70ee",
  null
  
)

export default component.exports